import React from 'react';
import { PermissionsContext } from './permissions-context';
export const PermissionsProvider = ({ children, permissionsState }) => {
    const ctxValue = React.useMemo(() => ({
        getPermission: (props) => {
            if ('comment' in props) {
                return permissionsState[props.action](props.comment);
            }
            return permissionsState[props.action];
        },
    }), [permissionsState]);
    return React.createElement(PermissionsContext.Provider, { value: ctxValue }, children);
};
//# sourceMappingURL=permissions-provider.js.map